var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZuixiaohua(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 10.3h-2.5a.5.5 0 00-.5.5v2.5M2.8 5.8h2.5a.5.5 0 00.5-.5V2.8M2.8 10.3h2.5a.5.5 0 01.5.5v2.5M13.3 5.8h-2.5a.5.5 0 01-.5-.5V2.8",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_zuixiaohua.79a2bfda.svg";
export { SvgTongyongZuixiaohua as ReactComponent };